import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import BlockItems from 'Views/Page/Content/Modal/Layouts/PlannerGuideLayout/Layout/components/BlockItems';
import NeverIncludeItems from 'Views/Page/Content/Modal/Layouts/PlannerGuideLayout/Layout/components/NeverIncludeItems';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';


const Layout = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  const {
    clearModalCollection,
  } = useModalContext();

  return (
    <>
      <MetaField attr={'title'} />
      <DialogContent>
        <FDStack direction={'column'} spacing={2}>
          <FDStack direction={'column'} spacing={6}>
            <MetaField attr={'subtitle'} />
            <BlockItems
              title={resource.meta().field('blockItems').attr('prompt')}
              items={resource.attr('blockItems').resources().list()}
            />
            <NeverIncludeItems
              title={resource.meta().field('neverIncludeItems').attr('prompt')}
              items={resource.attr('neverIncludeItems').resources().list()}
            />
          </FDStack>
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionButton label={'Close'} onClick={clearModalCollection} {...dataAttrs('close-planner-guide-dialog')} />
      </DialogActions>
    </>
  );
};

export default Layout;
